import React, { Fragment } from "react"
import styled from "styled-components"
import { defaultTheme, Button, Divider } from "@zenury/ui-components"
import { getAllPosts } from "../../lib/api/postsApi"
import { PostCard } from "../../components/PostCard"
import { getSizes } from "../../components/styles"
import { useRouter } from "next/router"
import { revalidateNext } from "../../utils/constants"
import { BackButton } from "../../components/neutral/BackButton"

const StyledPosts = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  ${getSizes};
`

const StyledDivider = styled(Divider)`
  margin: 28px 0;
`

export default function Tag({ allPosts }) {
  return (
    <StyledPosts>
      <BackButton />
      <>
        {allPosts.map((item, i) => (
          <Fragment key={item.slug}>
            <PostCard item={item} />
            {i < allPosts.length - 1 && <StyledDivider />}
          </Fragment>
        ))}
      </>
    </StyledPosts>
  )
}

export const getStaticProps = async (context) => {
  const filters = context?.params?.tag ? { tag: context?.params?.tag } : null

  const allPosts = getAllPosts(
    ["title", "date", "slug", "author", "coverImage", "excerpt", "tags"],
    filters
  )

  return {
    props: { allPosts },
    revalidate: revalidateNext,
  }
}

export async function getStaticPaths() {
  const allPosts = getAllPosts(
    ["title", "date", "slug", "author", "coverImage", "excerpt", "tags"],
    null
  )
  const allTags = allPosts.reduce((acc, post) => {
    const tags = post.tags
    if (tags) {
      tags.forEach((item) => {
        if (!acc.includes(item)) {
          acc.push(item)
        }
      })
    }
    return acc
  }, [])
  const paths = allTags.map((item) => ({
    params: {
      tag: item,
    },
  }))
  return {
    paths: paths,
    fallback: false,
  }
}
